import { ElementType } from 'react';
import { Icon, Link as ChakraLink, LinkProps } from '@chakra-ui/react';
import { ActiveLink } from './ActiveLink';

interface INavLinkProps extends LinkProps {
  icon: ElementType;
  children: string;
  href: string;
  shouldMatchExactHref?: boolean;
}

export function NavLink({
  icon,
  children,
  href,
  shouldMatchExactHref = false,
  ...rest
}: INavLinkProps) {
  return (
    <ActiveLink shouldMatchExactHref={shouldMatchExactHref} to={href}>
      <ChakraLink
        as="div"
        display="flex"
        align="center"
        ml="2"
        fontWeight="medium"
        fontSize="sm"
        {...rest}
      >
        <Icon as={icon} fontSize={18} mr="2" />

        {children}
      </ChakraLink>
    </ActiveLink>
  );
}
